import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { ParagraphComponent } from '@modules/auth/shared/paragraph/paragraph.component';
import { ProgressbarComponent } from '@modules/pages/vehicles/components/proposal/progressbar/progressbar.component';
import { ButtonComponent } from '@shared/components/button/button.component';

@Component({
  selector: 'success',
  standalone: true,
  imports: [ProgressbarComponent, ParagraphComponent, CommonModule, ButtonComponent],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss',
})
export class SuccessComponent implements OnInit {
  id: string | undefined = undefined;
  buttonLabel: string = 'Voltar para o início';

  constructor(
    private route: ActivatedRoute,
    private navigationService: NavigationService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params =>
      this.id = params['id']
    );
  }

    onButtonClick(): void {
      this.navigationService.navigateTo('/')

    }


}
